import { render, staticRenderFns } from "./reminder-unit.vue?vue&type=template&id=796427f4&scoped=true&"
import script from "./reminder-unit.vue?vue&type=script&lang=js&"
export * from "./reminder-unit.vue?vue&type=script&lang=js&"
import style0 from "./reminder-unit.vue?vue&type=style&index=0&id=796427f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796427f4",
  null
  
)

export default component.exports